export const getSheetCodeWithTaskGroupName = (sheetCode: string, taskGroupName: string) => {
  return `${sheetCode}/${taskGroupName}`;
};
